import { DownloadIcon } from '@chakra-ui/icons';
import { Button, CircularProgress, Flex, Text } from '@chakra-ui/react';
import { t } from '@lingui/macro';

import { useCertificateExport } from './use-certificate-export';

export function ExportButton() {
    const { exportReport, isExporting, canExport } = useCertificateExport();

    return (
        <Button
            variant={'unstyled'}
            isDisabled={!canExport}
            onClick={exportReport}
            aria-label={t`export`}
            h={'40px'}
            minW={'120px'}
            px={'20px'}
            display={'flex'}
            borderRadius={'40px'}
            border={'1px solid'}
            borderColor={canExport ? 'primary.400' : '#CBD3DC'}
            bg={'white'}
            _hover={canExport ? { bg: '#F4F8FA' } : undefined}
            _disabled={{ cursor: 'not-allowed', opacity: 0.6 }}
            opacity={isExporting ? '70%' : 'inherit'}
        >
            <Flex gap={'8px'} align={'center'} justify={'center'}>
                {isExporting
                    ? <CircularProgress isIndeterminate size={'16px'} />
                    : <DownloadIcon height={'16px'} width={'16px'} color={'primary.600'} />}
                <Text fontSize={'16px'} fontWeight={'500'} color={'primary.700'}>
                    {t`export`}
                </Text>
            </Flex>
        </Button>
    );
}
